function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgKalendarAvacon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "kalender_avacon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.768565,0,0,0.768565,5.7772,5.56034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.518,4.434L13.518,11.698",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "2.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.768565,0,0,0.768565,5.7772,5.56034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.435,4.463L36.435,11.726",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "2.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.768565,0,0,0.768565,5.7772,5.56034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.395,15.893L39.56,15.893",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "2.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.768565,0,0,0.768565,5.7772,5.56034)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.435,
    y: 22.143,
    width: 27.083,
    height: 16.587,
    style: {
      fill: "none",
      stroke: "rgb(0,85,100)",
      strokeWidth: "2.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.768565,0,0,0.768565,5.7772,5.56034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.435,8.601L44.768,8.601L44.768,45.059L5.185,45.059L5.185,8.601L13.52,8.601",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "2.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.768565,0,0,0.768565,5.7772,5.56034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.727,8.601L36.435,8.601",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "2.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.768565,0,0,0.768565,5.7772,5.56034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.472,30.436L38.52,30.436",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "2.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.768565,0,0,0.768565,5.7772,5.56034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.206,22.237L18.206,38.809",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "1.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.748,22.237L31.748,38.809",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "1.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.977,22.237L24.977,38.809",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "1.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.768565,0,0,0.768565,5.7772,5.56034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.206,22.237L18.206,38.809",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "2.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.748,22.237L31.748,38.809",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "2.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.977,22.237L24.977,38.809",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,85,100)",
      strokeWidth: "2.17px"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKalendarAvacon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/kalendar_avacon.df968464.svg";
export { ForwardRef as ReactComponent };